export default function groupBy<T>(
  items: T[],
  key: string
): { [key: string]: T[] } {
  return items.reduce(
    (result, item) => ({
      ...result,
      [(item as any)[key]]: [...(result[(item as any)[key]] || []), item]
    }),
    {} as { [key: string]: T[] }
  );
}
